import axios from 'axios';
import updateSelectFromArray from "../../new-car-pages/modules/details/finance/finance-types/update-select-from-array";
import numberFormat from '../../used-vue/api/NumberFormat';

const updateUsedModels = function(manufacturer) {
    return axios.post('/ajax/used-vehicles/homepage-options', {
        manufacturer: manufacturer
    });
};

const updateButtonText = function(buttonElement, usedMake, usedModel) {
    let count = usedModel.options[usedModel.selectedIndex].dataset.count;
    if (isNaN(count) || count <= 0) {
        buttonElement.innerHTML = 'Search used cars';
        return;
    }
    if (count == 1) {
        buttonElement.innerHTML = 'Search 1 used car';
    }
    buttonElement.innerHTML = 'Search ' + numberFormat(count) + ' used cars';
};

const setupUsedForm = function(usedForm) {
    if (!usedForm) {
        console.error("Couldn't find homepage used search form");
        return;
    }

    const usedMake = usedForm.querySelector('select[name="used_make"]');
    const usedModel = usedForm.querySelector('select[name="used_model"]');
    const submitButtonText = usedForm.querySelector('.btn--primary .homepage-hero__used-btn-txt');

    usedMake.addEventListener('change', function(event) {
        updateUsedModels(event.target.value)
        .then(response => {
            updateSelectFromArray(
                [
                    {select: true, model: '', count: response.data.count},
                    {model: '', count: response.data.count},
                    ...response.data.model
                ],
                usedModel,
                value => {
                    if (value.select) {
                        return 'Select Model';
                    }
                    if (value.model != '') {
                        return `${value.model} (${value.count})`
                    }
                    return 'Any model';
                },
                value => {
                    if (value.model != '') {
                        return value.model;
                    }
                    return '';
                },
                (value, option) => {
                    option.dataset.count = value.count;
                }
            );
            updateButtonText(submitButtonText, usedMake, usedModel);
        });
    })

    usedModel.addEventListener('change', function(event) {
        updateButtonText(submitButtonText, usedMake, usedModel);
    })
    updateButtonText(submitButtonText, usedMake, usedModel);
}

const submitUsedForm = function(form) {
    const usedMake = form.querySelector('select[name="used_make"]');
    const usedModel = form.querySelector('select[name="used_model"]');
    document.location = '/used-vehicles/results?manufacturer='+encodeURIComponent(usedMake.value)+'&model='+encodeURIComponent(usedModel.value);
}

export { setupUsedForm, submitUsedForm };


// WEBPACK FOOTER //
// ./resources/assets/js/homepages/modules/multi-brand-search-used.js